import App from '@/AppVendor'
import router from '@/router/vendor'
import store from '@/store'
import init from '@/init'

const APP_ID = 'vendor'

init(APP_ID, App, router, store)
